import {
    AfterViewInit,
    ComponentRef,
    Directive,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    TemplateRef,
    Type,
    ViewContainerRef,
    inject
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ISearchResponseRow, ISearchResultRenderer, SearchResultRendererType } from "../quick-search.models";
import { ArbetsorderRendererComponent } from "./arbetsorder-renderer/arbetsorder-renderer.component";
import { DefaultRendererComponent } from "./default-renderer.component";
import { HandelssortimentRendererComponent } from "./handelssortiment-renderer/handelssortiment-renderer.component";
import { KundLevTermOrderRendererComponent } from "./kund-lev-term-order-renderer/kund-lev-term-order-renderer.component";
import { NoResultRendererComponent } from "./no-result-renderer/no-result-renderer.component";
import { NoResultShowNavetRendererComponent } from "./no-result-show-navet-renderer/no-result-show-navet-renderer.component";
import { ProduktRendererComponent } from "./produkt-renderer/produkt-renderer.component";
import { ProduktinstruktionRendererComponent } from "./produktinstruktion-renderer/produktinstruktion-renderer.component";
import { VirkeskopskontraktRendererComponent } from "./virkeskopskontrakt-renderer/virkeskopskontrakt-renderer.component";

@Directive({ selector: "[raskRendererResolver]" })
export class RendererResolverDirective implements AfterViewInit, OnChanges, OnDestroy {
    cmpRef: ComponentRef<ISearchResultRenderer>;
    @Input() input: ISearchResponseRow;
    @Input() tooltipTemplate: TemplateRef<any>;
    @Input() type: SearchResultRendererType = "Default";

    @Input() searchExtended: () => void;
    private readonly components: Map<SearchResultRendererType, ISearchResultRenderer>;
    private readonly destroy$ = new Subject<void>();
    private readonly viewContainerRef = inject(ViewContainerRef);

    private isViewInitialized: boolean;

    constructor() {
        this.components = new Map([
            [
                "Default",
                DefaultRendererComponent
            ],
            [
                "Virkeskopskontrakt",
                VirkeskopskontraktRendererComponent
            ],
            [
                "VirkeskopskontraktFPV",
                VirkeskopskontraktRendererComponent
            ],
            [
                "Arbetsorder",
                ArbetsorderRendererComponent
            ],
            [
                "Kundorder",
                KundLevTermOrderRendererComponent
            ],
            [
                "Leverantorsorder",
                KundLevTermOrderRendererComponent
            ],
            [
                "Terminalorder",
                KundLevTermOrderRendererComponent
            ],
            [
                "Handelssortiment",
                HandelssortimentRendererComponent
            ],
            [
                "Produktinstruktion",
                ProduktinstruktionRendererComponent
            ],
            [
                "Produkt",
                ProduktRendererComponent
            ],
            [
                "NoResult",
                NoResultRendererComponent
            ],
            [
                "NoResultShowNavet",
NoResultShowNavetRendererComponent as any
            ]
        ]);
    }

    ngAfterViewInit(): void {
        this.isViewInitialized = true;
        this.update();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.update();
    }

    ngOnDestroy(): void {
        if (this.cmpRef) {
            this.cmpRef.destroy();
        }
        this.destroy$.next();
        this.destroy$.complete();
    }

    private update(): void {
        if (!this.isViewInitialized) {
            return;
        }

        if (this.cmpRef) {
            this.cmpRef.destroy();
        }

        let component: Type<DefaultRendererComponent> = DefaultRendererComponent;
        if (this.components.has(this.type)) {
            component = this.components.get(this.type) as any;
        }

        this.cmpRef = this.viewContainerRef.createComponent(component);
        this.cmpRef.instance.input = this.input;
        this.cmpRef.instance.tooltipTemplate = this.tooltipTemplate;
        if (this.cmpRef.instance.searchExtended) {
            this.cmpRef.instance.searchExtended.pipe(
                takeUntil(this.destroy$)
            ).subscribe(x => this.searchExtended());
        }
    }
}
